<template>
    <div class="checklist-template-index associate-app-settings">
        <transition mode="out-in">
            <div class="mt-4 grid grid-cols-8 grid-flow-row gap-4">
                <div class="col-span-8 p-4 relative border-2 rounded-lg">
                        <p class="inline-block text-gray-600 text-base font-bold mr-2">Associate App Settings</p>
                        <el-form label-position="top" size="small">
                            <div class="col-span-12 mt-2 md:col-span-6 lg:col-span-4">
                                <div v-if="!featurePermissions['featureEnabledAssociateApp']">
                                    <h1>Upgrade Required</h1>
                                    <p>
                                        To enable Associate App features, you'll need to upgrade your plan. Please contact Hera
                                        Support by chatting with us below.
                                    </p>
                                </div>
                                <div v-else>
                                    <div>Enable Associate App for {{ userInfo.tenant.companyName }}</div>
                                    <el-switch
                                        :class="{'switch-loading': permissionAssociateApp.loading}"
                                        v-model="permissionAssociateApp.value"
                                        active-color="#13ce66"
                                        :disabled="disabledPermissionAssociateApp"
                                        @change="toggleAssociateAppFeature">
                                    </el-switch>
                                </div>
                            </div>
                        </el-form>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { getTenantFeaturePermissions } from '@/middlewares/permissions';
import { updateTenantDetail } from '@/store/mutations';
import { mapState } from 'vuex';

export default{
    name: "AssociateAppToggle",
    data(){
        return {
            permissionAssociateApp: {
                loading: false,
                value: false
            }
        }
    },
    beforeMount() {
        this.permissionAssociateApp.value = this.userInfo?.tenant?.permissionAssociateApp;
    },
    computed: {
        ...mapState(['userInfo']),
        disabledPermissionAssociateApp(){
            if(!this.featurePermissions.featureEnabledAssociateApp){
                return true
            }
            if(this.userInfo.permissionFullAccess){
                return false
            }
            return true
        },
        featurePermissions(){
            return getTenantFeaturePermissions()
        }
    },
    methods: {
        async toggleAssociateAppFeature(value){
            this.permissionAssociateApp.loading = true
            try {
                const updated = await this.updatePermissionAssociateApp(value)
                this.permissionAssociateApp.value = updated.permissionAssociateApp
                this.$store.commit('setTenant', updated)
                this.$emit('permission-changed', updated.permissionAssociateApp)
            } catch (error) {
                this.displayUserError(error)
                this.permissionAssociateApp.value = !value
            }
            this.permissionAssociateApp.loading = false
        },
        async updatePermissionAssociateApp(value){
            const input = {
                id: this.userInfo.tenant.id,
                permissionAssociateApp: value
            }
            const response = await this.api(updateTenantDetail, { input })
            return response.data.updateTenant
        }
    }
}
</script>
<style lang="scss">
.checklist-template-index.associate-app-settings{
    .switch-loading{
        .el-switch__core::after {
            content: "";
            position: absolute;
            border: 2px solid theme('colors.blue.500');
            border-top-color: transparent;
            border-radius: 50%;
            animation: switch-loading-spin 1s linear infinite;
        }
    }
}
@keyframes switch-loading-spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
